<template>
    <div class="blog-wrapper">
        <img class="band-navbar" src="../assets/navbarImages/band.jpg"/>
        <div class="blog-content">
            <div>
                <h2 v-if="post.welcomeScreen">{{ post.title }}</h2>
                <h2 v-else>{{ post.blogTitle }}</h2>
                <p v-if="post.welcomeScreen">{{ post.blogPost }}</p>
                <p v-else class="content-preview" v-html="post.blogPreview"></p>
                <!-- <router-link class="link link-light" v-if="post.welcomeScreen" :to="{ name: 'ViewBlogPost', params: { blogid: 0 } }">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link> -->
                <router-link class="link-light" v-if="post.aboutUs" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: this.post.blogID } }">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link>
                <router-link class="link-light" v-if="post.program" :to="`/${$i18n.locale}/program`">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link>
                <router-link class="link-light" v-if="post.history" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: this.post.blogID } }">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link>
                <router-link class="link-light" v-if="post.contact" :to="`/${$i18n.locale}/contact`">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link>
                <router-link class="link-light" v-if="post.zimmerFrei" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: this.post.blogID } }">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link>
                <router-link class="link-light" v-if="!post.aboutUs && !post.program && !post.history && !post.contact && !post.zimmerFrei && !post.welcomeScreen" :to="{ name: 'ViewBlogPost', params: { lang: $i18n.locale, blogid: this.post.blogID } }">
                    {{ $t('blogPost.showMoreLink') }}<Arrow class="arrow arrow-light"/>
                </router-link>
            </div>
        </div>
        <div class="blog-photo">
                <img v-if="post.welcomeScreen" :src="require(`../assets/blogPhotos/${post.photo}.jpg`)" alt="" />
                <img v-else :src="require(`../assets/blogPhotos/${post.blogCoverPhoto}.jpg`)" alt="" />
        </div>

    </div>
</template>

<script>
import Arrow from "../assets/Icons/arrow-right-light.svg"

export default {
    name: "blogPost",
    props: ["post"],
    components: {
        Arrow,
    },
};
</script>

<style lang="scss" scoped>

    .blog-wrapper {
        display: flex;
        flex-direction: column;
        box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);
        background-color: #303030;
        color: #fff;
        
        @media(min-width: 700px) {
            min-height: 650px;
            max-height: none;
            flex-direction: row;
        }

        .band-navbar {
            width: 100%;
            height: 15px;
            left: 0;
            position: absolute;
        }

        .blog-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: justify;
            align-items: center;
            flex: 4;
            order: 2;
            @media(min-width: 700px) {
                order: 1;
            }
            @media(min-width: 800px) {
                flex: 3;
            }

            div {
                max-width: 500px;
                padding: 72px 24px;
                @media(min-width: 700px) {
                    padding: 40px 24px;
                }
                @media(min-width: 1600px) {
                    max-width: 700px;
                    padding: 48px 30px;
                }
                @media(min-width: 2000px) {
                    max-width: 900px;
                    padding: 56px 36px;
                }
                @media(min-width: 2560px) {
                    max-width: 1200px;
                    padding: 64px 42px;
                }

                h2 {
                    font-size: 28px;
                    font-weight: 300;
                    text-transform: uppercase;
                    margin-bottom: 24px;
                    line-height: 1.2;

                    @media(min-width: 700px) {
                        font-size: 32px;
                        margin-bottom: 30px;
                    }

                    @media(min-width: 1300px) {
                        font-size: 36px;
                        margin-bottom: 32px;
                    }

                    @media(min-width: 1600px) {
                        font-size: 40px;
                        margin-bottom: 36px;
                    }

                    @media(min-width: 2000px) {
                        font-size: 44px;
                        margin-bottom: 40px;
                    }

                    @media(min-width: 2560px) {
                        font-size: 48px;
                        margin-bottom: 44px;
                    }
                }

                p {
                    font-size: 16px;
                    font-weight: 300;
                    line-height: 1.7;
                    margin-bottom: 20px;

                    @media(min-width: 1600px) {
                        font-size: 18px;
                        line-height: 1.7;
                        margin-bottom: 22px;
                    }

                    @media(min-width: 2000px) {
                        font-size: 20px;
                        line-height: 1.7;
                        margin-bottom: 24px;
                    }

                    @media(min-width: 2560px) {
                        font-size: 22px;
                        line-height: 1.7;
                        margin-bottom: 26px;
                    }
                }

                .content-preview {
                    font-size: 18px;
                    text-align: justify;
                    margin-bottom: 20px;

                    @media(min-width: 1600px) {
                        font-size: 20px;
                        margin-bottom: 22px;
                    }

                    @media(min-width: 2000px) {
                        font-size: 22px;
                        margin-bottom: 24px;
                    }

                    @media(min-width: 2560px) {
                        font-size: 24px;
                        margin-bottom: 26px;
                    }
                }

                .link {
                    display: inline-flex;
                    align-items: center;
                    margin-top: 32px;
                    padding-bottom: 4px;
                    border-bottom: 1px solid transparent;
                    transition: 0.5s ease-in all;
                    color: white;
                    font-size: 16px;

                    @media(min-width: 1600px) {
                        font-size: 18px;
                    }

                    @media(min-width: 2000px) {
                        font-size: 20px;
                    }

                    @media(min-width: 2560px) {
                        font-size: 22px;
                    }
                    
                    &:hover {
                        border-bottom-color: #303030;
                    }
                }

                .link-light {
                    color: white;
                    text-decoration: none;
                    display: inline-flex;
                    align-items: center;
                    margin-top: 32px;
                    padding-bottom: 4px;
                    border-bottom: 1px solid transparent;
                    transition: 0.5s ease-in all;
                    font-size: 14px;

                    @media(min-width: 1600px) {
                        font-size: 16px;
                    }

                    @media(min-width: 2000px) {
                        font-size: 18px;
                    }

                    @media(min-width: 2560px) {
                        font-size: 20px;
                    }

                    &:hover {
                        border-bottom-color: orange !important;
                        color: orange !important;
                        transition: 0.5s ease-in all;

                        .arrow {
                            color: orange !important;
                        }
                    }
                }

                router-link.link-light {
                    &:hover {
                        border-bottom-color: orange !important;
                        color: orange !important;
                        transition: 0.5s ease-in all;

                        .arrow {
                            color: orange !important;
                        }
                    }
                }
            }
        }

        .blog-photo {
            order: 1;
            flex: 3;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

            @media(min-width: 700px) {
                order: 2;
            }

            @media(min-width: 800px) {
                flex: 4;
            }

            img {
                display: block;
                width: 100%;
                height: 300px; // Fixed height for mobile consistency
                object-fit: cover;

                @media(min-width: 700px) {
                    height: 100%; // Full height on desktop
                }

                // Adjust positioning for welcome screen photos to show faces properly
                &[src*="hauptseite-willkommen"] {
                    object-position: center 30%; // Move focus point down to show faces
                }
            }
        }

        &:nth-child(even) {
            .blog-content {
                order: 2;
            }
            .blog-photo {
                order: 1;
            }


        }
    }


</style>